<div class="menu dialog" (click)="close()">
  <div class="column hit" #result>
    <div class="artist mat-display-medium">{{activeHit?.artist}}</div>
    <div class="mat-display-small">{{activeHit?.name}}</div>
    <div class="mat-display-small">{{activeHit?.year}}</div>
    @if (correctAnswer) {
      <div class="correct-answer column">
        <div class="mat-body-large">{{'game.guess.types.' + guessType + '.title' | translate: guessTitleParams}}</div>
        <div class="mat-title-large">{{'game.guess.correctAnswer' | translate: {answer: correctAnswer} }}</div>
      </div>
    }
  </div>
  <div class="column team-results">
    @for (result of data.results; track result) {
      <app-team-guess-result [result]="result" [showCorrect]="showCorrect"></app-team-guess-result>
    }
  </div>
</div>
